import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Videos({ username, token, videos }) {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  const displayVideos = showAll ? videos.resources : videos.resources?.slice(0, 9);

  const handleVideoClick = (video) => {
    // Navigate to the post containing this video
    if (video.postId) {
      navigate(`/post/${video.postId}`);
    }
  };

  return (
    <div className="profile_card">
      <div className="profile_card_header">
        Videos
        <div 
          className="profile_header_link"
          onClick={() => setShowAll(!showAll)}
          style={{ cursor: "pointer" }}
        >
          {showAll ? "Show less" : "See all videos"}
        </div>
      </div>
      <div className="profile_card_count">
        {videos.total_count === 0
          ? "No videos"
          : videos.total_count === 1
          ? "1 Video"
          : `${videos.total_count} videos`}
      </div>
      {videos.total_count > 0 && (
        <div className={`profile_card_grid ${showAll ? "show_all_videos" : ""}`}>
          {displayVideos &&
            displayVideos.map((video, index) => (
              <div 
                className="profile_video_card" 
                key={`${video.postId}-${index}`}
                onClick={() => handleVideoClick(video)}
                style={{ cursor: "pointer" }}
              >
                <video 
                  preload="metadata" 
                  muted
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100%;background:#f0f2f5;color:#65676b;font-size:12px;">Video not available</div>';
                  }}
                >
                  <source src={video.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div className="video_overlay">
                  <i className="play_icon"></i>
                </div>
              </div>
            ))}
        </div>
      )}
      {videos.total_count === 0 && (
        <div className="no_videos">
          <div style={{ 
            textAlign: "center", 
            padding: "20px", 
            color: "#65676b",
            fontSize: "14px"
          }}>
            No videos to show
          </div>
        </div>
      )}
    </div>
  );
} 